import { getCookie, siteAPI } from "../../api/axios";
import { getMapLayerById } from "../utils/mapUtils";
import { Feature } from "ol";
import { LineString, Point, Polygon, Circle } from "ol/geom.js";
import { Style, Fill, Stroke, Circle as CircleStyle, Text } from "ol/style.js";
import { drawStyleFunction } from "../Measure/measureUtils";

/* 

    API Calls

*/
export const GetBookMarks = async () => {
    let token = getCookie("ast");
    if (token) {
        //Authenticated User
        const response = await siteAPI.get("Bookmarks", {});

        if (response?.data) {
            return response?.data;
        } else {
        }
    } else {
        //Guest User
        var i = 0,
            sKey;
        let tempArr = [];
        for (; (sKey = window.localStorage.key(i)); i++) {
            if (sKey.toLowerCase().startsWith("bookmark")) {
                tempArr.push(JSON.parse(window.localStorage.getItem(sKey)));
            }
        }
        tempArr.sort((p1, p2) =>
            p1.bookMarkName > p2.bookMarkName
                ? 1
                : p1.bookMarkName < p2.bookMarkName
                ? -1
                : 0
        );

        return tempArr;
    }
};

export const GetBookMark = async (id, bookmarks) => {
    var headersVal = null;
    let token = getCookie("ast");
    if (token) {
        //Authenticated User
        headersVal = { Authorization: "Bearer " + token };
        const response = await siteAPI.get(`${"Bookmarks/" + id}`, {
            headers: headersVal,
        });

        if (response?.data) {
            return response?.data;
        } else {
        }
    } else {
        //Guest User
        return bookmarks.find((x) => x.data.createdDate === id);
    }
};

export const SaveBookMark = async (data, name) => {
    var headersVal = null;
    let token = getCookie("ast");
    if (token) {
        //Authenticated User
        headersVal = { Authorization: "Bearer " + token };
        const response = await siteAPI.post("Bookmarks", data, {
            headers: headersVal,
        });

        if (response?.data) {
        } else {
        }
    } else {
        //Guest User
        localStorage.setItem(`${"bookMark_" + name}`, JSON.stringify(data));
    }
};

export const DeleteBookMark = async (id, bookmarks) => {
    var headersVal = null;
    let token = getCookie("ast");
    if (token) {
        //Authenticated User
        headersVal = { Authorization: "Bearer " + token };
        const response = await siteAPI.delete(`${"Bookmarks/" + id}`, {
            headers: headersVal,
        });
        if (response?.data) {
        } else {
        }
    } else {
        //Guest User
        let bookmark = await GetBookMark(id, bookmarks);
        localStorage.removeItem(`${"bookMark_" + bookmark.bookMarkName}`);
    }
};

export const UpdateBookMarkName = async (id, bookmarks, newName) => {
    let headersVal = null;
    let token = getCookie("ast");
    const bookmark = await GetBookMark(id, bookmarks);
    if (newName !== bookmark.bookMarkName) {
        bookmark.bookMarkName = newName;
        if (token) {
            try {
                headersVal = { Authorization: "Bearer " + token };
                const response = await siteAPI.put(
                    `Bookmarks/${id}`,
                    bookmark,
                    headersVal
                );
                return response.data.bookMarkName;
            } catch (error) {
                console.error(error);
            }
        } else {
            localStorage.setItem(`${"bookMark_" + newName}`, JSON.stringify(bookmark));
            localStorage.removeItem(`${"bookMark_" + bookmark.bookMarkName}`);
            return newName;
        }
    }
};

/* 

    Helper functions

*/

export const getSubLayerIds = (layerGraph, group) => {
    const subLayerIds = layerGraph
        .find((parent) => group.DisplayName === parent.DisplayName)
        ?.SubLayers?.map((child) => child.Id);
    return subLayerIds;
};

/*

    Save markup utils

*/

export const serializeMarkup = (map) => {
    const layer = getMapLayerById(map, "drawLayer");
    const features = layer.getSource().getFeatures();
    const featuresArray = [];
    features.forEach((f) => {
        const style = f.getStyle();
        const geom = f.getGeometry();
        switch (geom.getType()) {
            case "Point":
                if (style.getText() != null) {
                    const textObject = serializeText(geom, style);
                    featuresArray.push(textObject);
                } else {
                    const pointObject = serializeShape(geom, style);
                    featuresArray.push(pointObject);
                }
                break;
            case "LineString":
                const lineStringObject = serializeShape(geom, style);
                featuresArray.push(lineStringObject);
                break;
            case "Circle":
                const circleObject = serializeShape(geom, style);
                featuresArray.push(circleObject);
                break;
            case "Polygon":
                const polygonObject = serializeShape(geom, style);
                featuresArray.push(polygonObject);
                break;

            default:
                console.log("case missed");
        }
    });
    return featuresArray;
};

export const serializeShape = (geom, style) => {
    const featureStyle = serializeStyle(style);
    const geomType = geom.getType();
    return {
        Type: geomType,
        Style: featureStyle,
        Geometry: geom.flatCoordinates,
    };
};

export const serializeText = (geom, style) => {
    const text = style.getText();
    const TextStyle = {
        fill: { color: text.getFill().getColor() },
        font: text.getFont(),
        text: text.getText(),
        stroke: {
            color: text.getStroke().getColor(),
            width: text.getStroke().getWidth(),
        },
    };
    const featureStyle = serializeStyle(style);
    Object.assign(featureStyle, { TextStyle });
    return {
        Type: "Text",
        Style: featureStyle,
        Geometry: geom.flatCoordinates,
    };
};

const serializeStyle = (style) => {
    if (typeof style === "function") {
        return "drawStyleFunction";
    }
    const pointStyle = style?.getImage();
    const stroke = {
        color: style?.getStroke()?.getColor(),
        width: style?.getStroke()?.getWidth(),
    };
    const fill = { color: style?.getFill()?.getColor() };
    const CircleStyle = {
        radius: pointStyle?.getRadius(),
        fill: { color: pointStyle?.getFill()?.getColor() },
    };
    return { stroke, fill, CircleStyle };
};

export const deserializeMarkup = (markupData, unitArgs) => {
    const markup = JSON.parse(markupData);
    const markupFeatures = [];
    markup.forEach((m) => {
        let feature;
        let constructor;
        switch (m?.Type) {
            case "Point":
                constructor = Point;
                feature = deserializeFeature(m, constructor, unitArgs);
                break;
            case "Text":
                feature = deserializeText(m);
                break;
            case "LineString":
                constructor = LineString;
                feature = deserializeFeature(m, constructor, unitArgs);
                break;
            case "Polygon":
                constructor = Polygon;
                feature = deserializeFeature(m, constructor, unitArgs);
                break;
            case "Circle":
                constructor = Circle;
                feature = deserializeFeature(m, constructor, unitArgs);
                break;
        }
        markupFeatures.push(feature);
    });
    return markupFeatures;
};

const deserializeStyle = (styleObj) => {
    if (styleObj === "drawStyleFunction") {
        return styleObj;
    }
    const circle = styleObj?.CircleStyle;

    const style = new Style({
        zIndex: 1000,
        fill: new Fill({
            color: styleObj?.fill?.color,
        }),
        image: new CircleStyle({
            radius: circle?.radius,
            fill: new Fill({
                color: circle?.fill?.color,
            }),
        }),
        stroke: new Stroke({
            color: styleObj?.stroke?.color,
            width: styleObj?.stroke?.width,
        }),
    });
    return style;
};

export const deserializeFeature = (markupFeature, constructor, unitArgs) => {
    const args =
        markupFeature.Type === "Circle"
            ? [markupFeature.Geometry, undefined, "XY"]
            : markupFeature.Type === "Polygon"
            ? [markupFeature.Geometry, "XY", [markupFeature.Geometry.length]]
            : [markupFeature.Geometry, "XY"];
    const style = deserializeStyle(markupFeature.Style, unitArgs);
    const feature = new Feature({
        geometry: new constructor(...args),
    });
    if (style === "drawStyleFunction") {
        const uid = feature.ol_uid;
        feature.setId(`measure-feature-${uid}`);
        feature.setStyle((feature) => {
            return drawStyleFunction(feature, vectorStyle, unitArgs);
        });
    } else {
        feature.setStyle(style);
    }
    return feature;
};

export const deserializeText = (markupFeature) => {
    const mStyle = markupFeature.Style;
    const text = mStyle.TextStyle;
    const style = deserializeStyle(mStyle);
    const olText = new Text({
        text: text.text,
        font: text.font,
        fill: new Fill({ color: text.fill.color }),
        stroke: new Stroke({
            color: text.stroke.color,
            width: text.stroke.width,
        }),
    });

    style.setText(olText);
    const feature = new Feature({ geometry: new Point(markupFeature.Geometry) });
    feature.setStyle(style);
    return feature;
};

const vectorStyle = new Style({
    zIndex: 1000,
    fill: new Fill({
        color: "rgba(0, 0, 255, 0.1)",
    }),
    stroke: new Stroke({
        color: "rgba(0, 0, 255, 0.7)",
        width: 2,
    }),
    image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
            color: "rgba(0, 0, 255, 0.7)",
        }),
        fill: new Fill({
            color: "rgba(0, 0, 255, 0.2)",
        }),
    }),
});
